import { useEffect } from 'react'

const useViewportScale = () => {
  useEffect(() => {
    const setViewportScale = () => {
      const userAgent = navigator.userAgent || navigator.vendor
      const isIOS = /iPad|iPhone|iPod/.test(userAgent)
      const isAndroid = /Android/.test(userAgent)
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)
      
      // Obter informações da tela
      const screenWidth = window.screen.width
      
      let initialScale = 1
      
      if (isMobile) {
        if (isIOS) {
          // Escalas mais agressivas para iPhone
          if (screenWidth <= 375) {
            // iPhone SE, mini - mais reduzido
            initialScale = 0.7
          } else if (screenWidth <= 390) {
            // iPhone 12, 13, 14 padrão - escala que você mencionou
            initialScale = 0.8
          } else if (screenWidth <= 428) {
            // iPhone 12 Pro Max, 13 Pro Max, 14 Plus/Pro Max
            initialScale = 0.8
          } else {
            // iPad e outros
            initialScale = 0.85
          }
        } else if (isAndroid) {
          // Escalas bem reduzidas para Android
          if (screenWidth <= 360) {
            // Dispositivos Android pequenos - muito compacto
            initialScale = 0.55
          } else if (screenWidth <= 400) {
            // Dispositivos Android médios - bem compacto
            initialScale = 0.65
          } else {
            // Dispositivos Android grandes - compacto
            initialScale = 0.7
          }
        } else {
          // Outros dispositivos móveis
          initialScale = 0.85
        }
      }
      
      // Buscar ou criar a meta tag viewport
      let viewportMeta = document.querySelector('meta[name="viewport"]') as HTMLMetaElement
      
      if (!viewportMeta) {
        viewportMeta = document.createElement('meta')
        viewportMeta.name = 'viewport'
        document.head.appendChild(viewportMeta)
      }
      
      // Configurar o conteúdo da meta tag viewport
      const viewportContent = [
        'width=device-width',
        `initial-scale=${initialScale}`,
        `maximum-scale=${initialScale}`,
        'user-scalable=no'
      ].join(', ')
      
      viewportMeta.content = viewportContent
      
      console.log(`Viewport configurado: ${viewportContent}`)
      console.log(`Dispositivo: ${isIOS ? 'iOS' : isAndroid ? 'Android' : 'Outros'}, Largura: ${screenWidth}px, Escala: ${initialScale}`)
    }
    
    // Aplicar imediatamente
    setViewportScale()
    
    // Reconfigurar em mudanças de orientação
    const handleOrientationChange = () => {
      // Aguardar um pouco para que a orientação seja aplicada
      setTimeout(setViewportScale, 100)
    }
    
    window.addEventListener('orientationchange', handleOrientationChange)
    window.addEventListener('resize', handleOrientationChange)
    
    return () => {
      window.removeEventListener('orientationchange', handleOrientationChange)
      window.removeEventListener('resize', handleOrientationChange)
    }
  }, [])
}

export default useViewportScale 